import React from 'react';
import styled from 'styled-components';
import { Flex } from '@rebass/grid';
import { isMobile } from 'app/helpers/utils';

const SideItem = styled(Flex).attrs({
  mx: 20,
  mt: 20,
  p: 20,
  mb: 40,
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: props => props.justifyContent,
  alignItems: 'flex-start',
})`
  background: #fff;
  font-weight: 500;
  font-size: 16px;
  color: #4e4f57;
  text-align: center;
  border-width: 2px;
  border-style: solid;
  border-image: linear-gradient(#f49f61, #d85c52) 2;
`;

export default SideItem;
